import { render, staticRenderFns } from "./tna-report.vue?vue&type=template&id=68440334&scoped=true"
import script from "./tna-report.vue?vue&type=script&lang=js"
export * from "./tna-report.vue?vue&type=script&lang=js"
import style0 from "./tna-report.vue?vue&type=style&index=0&id=68440334&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68440334",
  null
  
)

export default component.exports